// YK 말소대행 대기 탭 — 대행사 하위 거래처 신청의 수거 위치 묶음 · 경로 라벨 · '○○가 신청' (순수 함수).
// 서버가 행에 붙이는 키: pickupKey(공백 정리된 효과 수거 주소) · unitName · accountName · accountKind · requesterIsBroker.
// 구 서버(키 없음)에서는 모든 함수가 현행 동작(업체명 묶음 · 업체명 표시)으로 떨어진다.
// 규칙 정본: 앱 rd_requests 의 pickup_bands.dart 와 같은 결과(GUIDE-client §1.3).
import { koJosa } from '../v2/malso/koJosa';

var NONAME = '미지정';

function companyKey(r) { return (r && r.requesterCompanyName) || NONAME; }

/// 새 서버가 pickupKey 를 내려주는 행인가 (구 서버 = 키 없음).
function hasKey(r) { return !!r && typeof r.pickupKey === 'string'; }

/// 목록에 pickupKey 가 있는 행이 하나라도 있으면 수거 위치 묶음 모드를 쓸 수 있다.
export function hasPickupKeys(rows) { return (rows || []).some(hasKey); }

/// 묶음 키 — 직접 방문·주소 없음·구 서버는 업체별('co:'), 그 외는 정리된 수거 주소('addr:').
export function bandKeyOf(r) {
  if (!hasKey(r) || r.pickupKey === '' || r.intake_method === '방문') return 'co:' + companyKey(r);
  return 'addr:' + r.pickupKey;
}

export function isAddressBand(key) { return String(key).indexOf('addr:') === 0; }

/// 밴드 제목 — 주소 밴드는 주소, 업체 밴드는 업체명.
export function bandTitleOf(key) { return String(key).replace(/^(addr|co):/, ''); }

/// 경로 라벨 — '오토상사 › 동해모터스' · '오토상사 (본인)' · 하위 회사가 직접 넣은 건은 거래처명.
export function pathLabel(r) {
  r = r || {};
  if (r.accountKind !== 'broker' || !r.unitName) return companyKey(r);
  if (r.unitName === r.accountName) return r.unitName + ' (본인)';
  if (r.requesterIsBroker) return r.accountName + ' › ' + r.unitName;
  return r.unitName;
}

/// '서해무역이 신청' — 하위 회사가 직접 넣은 건만. 아니면 ''.
export function requestedByLabel(r) {
  r = r || {};
  if (r.accountKind !== 'broker' || r.requesterIsBroker !== false || !r.requesterCompanyName) return '';
  return r.requesterCompanyName + koJosa(r.requesterCompanyName, '이', '가') + ' 신청';
}

/// 밴드 업체 줄 — 경로가 모두 같으면 그 경로, 아니면 신청 업체명(중복 제거, 첫 등장 순) ' · ' 연결.
export function bandCompanies(rows) {
  var list = rows || [];
  if (!list.length) return '';
  var first = pathLabel(list[0]);
  if (list.every(function (r) { return pathLabel(r) === first; })) return first;
  var names = [];
  list.forEach(function (r) { var n = companyKey(r); if (names.indexOf(n) < 0) names.push(n); });
  return names.join(' · ');
}

/// 밴드 첫 등장 순으로 모은다 — 같은 밴드는 떨어져 있어도 한 덩어리, 밴드 안 순서는 입력 순서 유지.
export function orderByBand(rows) {
  var order = [];
  var byKey = {};
  (rows || []).forEach(function (r) {
    var k = bandKeyOf(r);
    if (!byKey[k]) { byKey[k] = []; order.push(k); }
    byKey[k].push(r);
  });
  return order.reduce(function (acc, k) { return acc.concat(byKey[k]); }, []);
}

/// rows[from] 부터 같은 밴드가 이어지는 구간 (orderByBand 로 모은 뒤에만 쓴다).
export function bandRowsFrom(rows, from) {
  var k = bandKeyOf(rows[from]);
  var out = [];
  for (var i = from; i < rows.length && bandKeyOf(rows[i]) === k; i++) out.push(rows[i]);
  return out;
}
